import Link from "@mui/material/Link";
import { createLink } from "@tanstack/react-router";

/**
 * A text link to an in-app route: MUI `Link` styling with the router's typed
 * `to`, `params` and `search`.
 */
export const RouterLink = createLink(Link);
